/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCurrentHoldings} from '../api'

 export const useQueryGetCurrentHoldings = createReactQueryHook('getCurrentHoldings', getCurrentHoldings)
